import comp from "./OTPInput";
export default comp;
